import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../assets/recommendation/manual-03_img1.gif'
import _imports_1 from '../../assets/recommendation/manual-03_img1.png'
import _imports_2 from '../../assets/recommendation/manual-03_img2.png'
import _imports_3 from '../../assets/recommendation/manual-03_img3.png'
import _imports_4 from '../../assets/recommendation/manual-03_img4.png'


const _hoisted_1 = {
  class: "main",
  id: "main"
}
const _hoisted_2 = { class: "contents__manual is-color-green" }
const _hoisted_3 = { class: "section__manual section__manual__mv" }
const _hoisted_4 = { class: "inner__manual" }
const _hoisted_5 = { class: "mv__manual" }
const _hoisted_6 = { class: "nav__manual" }
const _hoisted_7 = { class: "nav__wrap__manual" }
const _hoisted_8 = { class: "nav__menu__manual" }
const _hoisted_9 = { class: "nav__menu__manual" }
const _hoisted_10 = { class: "nav__menu__manual" }
const _hoisted_11 = { class: "nav__menu__manual" }
const _hoisted_12 = {
  class: "section__manual section__manual__default section__manual__colored",
  id: "content1"
}
const _hoisted_13 = { class: "inner__manual" }
const _hoisted_14 = { class: "img__manual" }
const _hoisted_15 = {
  class: "section__manual section__manual__default",
  id: "content2"
}
const _hoisted_16 = { class: "inner__manual" }
const _hoisted_17 = { class: "img__manual" }
const _hoisted_18 = { class: "note__manual" }
const _hoisted_19 = {
  class: "section__manual section__manual__default section__manual__colored",
  id: "content3"
}
const _hoisted_20 = { class: "inner__manual" }
const _hoisted_21 = { class: "img__manual" }
const _hoisted_22 = { class: "conversion__manual" }
const _hoisted_23 = { class: "conversion__wrap__manual" }
const _hoisted_24 = { class: "conversion__app__manual" }
const _hoisted_25 = { class: "conversion__icon__manual" }
const _hoisted_26 = { class: "icon" }
const _hoisted_27 = { class: "conversion__links__manual" }
const _hoisted_28 = { class: "conversion__link__manual" }
const _hoisted_29 = { class: "txt" }
const _hoisted_30 = { class: "conversion__link__manual" }
const _hoisted_31 = { class: "txt" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("main", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("section", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _cache[12] || (_cache[12] = _createElementVNode("h1", { class: "ttl__h1__manual" }, "スマホが医療機関との距離を近づける「オンライン診療」とは？", -1)),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("img", {
              onLoad: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onImgLoad && _ctx.onImgLoad(...args))),
              class: "has-bgcolor",
              src: _imports_0,
              alt: ""
            }, null, 32)
          ]),
          _cache[13] || (_cache[13] = _createElementVNode("p", { class: "txt__manual" }, "スマートフォンはWEBを通じてさまざまな世界と簡単につながり、生活のお困りごとを解消してくれるのが便利なポイント！体調が少し悪いかな…というとき、おうち時間でお医者さんのオンライン診療を受けられるアプリサービスもあります。", -1))
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("ul", _hoisted_7, [
          _createElementVNode("li", _hoisted_8, [
            _createElementVNode("a", {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.gotoSection('content1')))
            }, "スマホで手早くお医者さんに頼る")
          ]),
          _createElementVNode("li", _hoisted_9, [
            _createElementVNode("a", {
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.gotoSection('content2')))
            }, "オンラインならではのメリット")
          ]),
          _createElementVNode("li", _hoisted_10, [
            _createElementVNode("a", {
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.gotoSection('content3')))
            }, "まずアプリのインストール")
          ]),
          _createElementVNode("li", _hoisted_11, [
            _createElementVNode("a", {
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.gotoSection('content4')))
            }, "通院の困難を解決する新手法")
          ])
        ])
      ]),
      _createElementVNode("section", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _cache[14] || (_cache[14] = _createElementVNode("h2", { class: "ttl__h2__manual" }, "スマホで手早くお医者さんに頼る", -1)),
          _cache[15] || (_cache[15] = _createElementVNode("p", { class: "txt__manual" }, "「あれ、ちょっと熱っぽいかな」と体調の変化に気がつきながら、移動にも時間がかかるため病院へ行く時間がつくれず、無理をしてしまう。ですが、後々の悪化や周囲への影響があるのではと心配。気持ち的にもストレスになり、余計に体調が悪くなってしまう。こんな負のスパイラルから脱出するためにも、お手元のスマートフォンからお医者さんを頼りましょう。それが、「オンライン診療」です。", -1)),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("img", {
              onLoad: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.onImgLoad && _ctx.onImgLoad(...args))),
              src: _imports_1,
              alt: ""
            }, null, 32)
          ])
        ])
      ]),
      _createElementVNode("section", _hoisted_15, [
        _createElementVNode("div", _hoisted_16, [
          _cache[20] || (_cache[20] = _createStaticVNode("<h2 class=\"ttl__h2__manual\" data-v-38b60e60>オンラインならではのメリット</h2><p class=\"txt__manual\" data-v-38b60e60>スマートフォンやタブレット、PCなどを利用して、病院の予約や受付から診療後の決済まで実際に医療機関に足を運ばなくても診察・治療を受けられることを「オンライン診療」と呼びます。メリットとしては主に次のことが挙げられます。</p><ol class=\"list__manual\" data-v-38b60e60><li data-v-38b60e60><h4 class=\"list__ttl__manual\" data-v-38b60e60><span class=\"list__num__manual\" data-v-38b60e60><span class=\"num\" data-v-38b60e60></span></span><span class=\"list__txt__manual\" data-v-38b60e60>受付＆会計で待つ時間が短くなる</span></h4></li><li data-v-38b60e60><h4 class=\"list__ttl__manual\" data-v-38b60e60><span class=\"list__num__manual\" data-v-38b60e60><span class=\"num\" data-v-38b60e60></span></span><span class=\"list__txt__manual\" data-v-38b60e60>他の患者と会わずプライバシーが守られる</span></h4></li><li data-v-38b60e60><h4 class=\"list__ttl__manual\" data-v-38b60e60><span class=\"list__num__manual\" data-v-38b60e60><span class=\"num\" data-v-38b60e60></span></span><span class=\"list__txt__manual\" data-v-38b60e60>院内感染および二次感染のリスクの減少</span></h4></li></ol>", 3)),
          _createElementVNode("div", _hoisted_17, [
            _createElementVNode("img", {
              onLoad: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.onImgLoad && _ctx.onImgLoad(...args))),
              src: _imports_2,
              alt: ""
            }, null, 32)
          ]),
          _cache[21] || (_cache[21] = _createElementVNode("p", { class: "txt__manual" }, "もちろん、オンラインで行われるのですから、視診や触診などが必要となる診察には向いていません。検査などが必要になる初診には適さないかもしれませんが、継続的な経過をチェックする“再診”や定期的に通い、こちらの身体をよく知ってもらっているかかりつけ医の診察などであれば、便利に利用できるでしょう。", -1)),
          _createElementVNode("p", _hoisted_18, [
            _cache[16] || (_cache[16] = _createTextVNode("※患者の疾患や状態等によりオンライン診療では受診できない場合があります。主治医とご相談のうえご利用をおすすめします。", -1)),
            _cache[17] || (_cache[17] = _createElementVNode("br", null, null, -1)),
            _cache[18] || (_cache[18] = _createTextVNode("※オンライン診療に関する詳細は", -1)),
            _createElementVNode("a", {
              class: "link",
              onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.click('https://www.mhlw.go.jp/stf/seisakunitsuite/bunya/kenkou_iryou/iryou/rinsyo/index_00010.html'))),
              target: "_blank"
            }, "「オンライン診療に関するホームページ｜厚生労働省」"),
            _cache[19] || (_cache[19] = _createTextVNode("をご覧ください。", -1))
          ])
        ])
      ]),
      _createElementVNode("section", _hoisted_19, [
        _createElementVNode("div", _hoisted_20, [
          _cache[22] || (_cache[22] = _createElementVNode("h2", { class: "ttl__h2__manual" }, "まずアプリのインストール", -1)),
          _cache[23] || (_cache[23] = _createElementVNode("p", { class: "txt__manual" }, "試してみたいと思った場合には、まず専用のアプリをインストールする必要があります。受診を考える医療機関が指定する「オンライン診療アプリ」を確認し、ダウンロードからはじめましょう。", -1)),
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("img", {
              onLoad: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.onImgLoad && _ctx.onImgLoad(...args))),
              src: _imports_3,
              alt: ""
            }, null, 32)
          ]),
          _cache[24] || (_cache[24] = _createElementVNode("p", { class: "txt__manual" }, "例えば、「CLINICS（クリニクス）」というアプリは、日本全国1,000以上の医療機関で導入（2020年4月現在）されていてアプリ自体の利用料は無料。まだ「検討してから」という方にとっては、頼りにする病院の選択肢も多く、使い勝手がいいかもしれません。", -1))
        ])
      ]),
      _cache[30] || (_cache[30] = _createStaticVNode("<section class=\"section__manual section__manual__default\" id=\"content4\" data-v-38b60e60><div class=\"inner__manual\" data-v-38b60e60><h2 class=\"ttl__h2__manual\" data-v-38b60e60>通院の困難を解決する新手法</h2><p class=\"txt__manual\" data-v-38b60e60>オンライン診療は症状により適さないこともあり、病気や体調の変化でお困りのすべての皆さんにおすすめできるわけではないのですが、存在すら知らなかった方には通院の困難を解消する手段が増えるわけです。電話やメールだけの利用ではもったいない、スマートフォンの可能性と未来がそこにあるのではないでしょうか。</p></div></section><section class=\"section__manual section__manual__default\" data-v-38b60e60><div class=\"inner__manual\" data-v-38b60e60><p class=\"note__manual\" data-v-38b60e60>※掲載している情報は、2020年7月10日現在のものです。内容・仕様など予告なしに変更されることがありますのであらかじめご了承ください。</p></div></section>", 2)),
      _createElementVNode("div", _hoisted_22, [
        _createElementVNode("div", _hoisted_23, [
          _createElementVNode("div", _hoisted_24, [
            _createElementVNode("div", _hoisted_25, [
              _createElementVNode("div", _hoisted_26, [
                _createElementVNode("img", {
                  onLoad: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.onImgLoad && _ctx.onImgLoad(...args))),
                  src: _imports_4,
                  alt: ""
                }, null, 32)
              ])
            ]),
            _cache[25] || (_cache[25] = _createElementVNode("p", { class: "conversion__ttl__manual" }, [
              _createElementVNode("span", { class: "ttl" }, [
                _createTextVNode("CLINICS (クリニクス)"),
                _createElementVNode("br"),
                _createTextVNode("for auスマートパス")
              ]),
              _createElementVNode("span", { class: "txt" }, [
                _createTextVNode("価格：無料"),
                _createElementVNode("br"),
                _createTextVNode("※価格は変更される場合がございます")
              ])
            ], -1))
          ]),
          _createElementVNode("ul", _hoisted_27, [
            _createElementVNode("li", _hoisted_28, [
              _createElementVNode("p", _hoisted_29, [
                _cache[26] || (_cache[26] = _createTextVNode("Google Playは", -1)),
                _createElementVNode("a", {
                  class: "link",
                  onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.click('https://play.google.com/store/apps/details?id=life.medley.clinics'))),
                  target: "_blank"
                }, "こちら"),
                _cache[27] || (_cache[27] = _createTextVNode("から", -1))
              ])
            ]),
            _createElementVNode("li", _hoisted_30, [
              _createElementVNode("p", _hoisted_31, [
                _cache[28] || (_cache[28] = _createTextVNode("AppStoreは", -1)),
                _createElementVNode("a", {
                  class: "link",
                  onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.click('https://apps.apple.com/jp/app/clinics-%E3%82%AF%E3%83%AA%E3%83%8B%E3%82%AF%E3%82%B9/id1106261604'))),
                  target: "_blank"
                }, "こちら"),
                _cache[29] || (_cache[29] = _createTextVNode("から", -1))
              ])
            ])
          ])
        ])
      ])
    ])
  ]))
}